import makeSlice from '@web/slices/deliveryTracking/sliceMaker'

const slice = makeSlice()

export default slice.reducer
